export default "__VITE_ASSET__c32ed6aa__"